import React from "react";

const Footer = () => {
  return (
    <div>
      <footer>
        <div className="container">
          <p>© 2025 Bhuvaneshwari C. All Rights Reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
